import { render, staticRenderFns } from "./CookBookPicUpload.vue?vue&type=template&id=0b7a5ca7&scoped=true&"
import script from "./CookBookPicUpload.vue?vue&type=script&lang=js&"
export * from "./CookBookPicUpload.vue?vue&type=script&lang=js&"
import style0 from "./CookBookPicUpload.vue?vue&type=style&index=0&id=0b7a5ca7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7a5ca7",
  null
  
)

export default component.exports